export const WIDGET_CSS = `
:host { all: initial; }
* { box-sizing: border-box; font-family: -apple-system, system-ui, sans-serif; }
.dp-bar { position: fixed; left: 0; right: 0; bottom: 0; z-index: 2147483646;
  background: #fff; border-top: 1px solid #e2e6ec; box-shadow: 0 -6px 24px rgba(20,30,50,.12);
  padding: 14px 16px; display: flex; gap: 16px; align-items: center; flex-wrap: wrap; }
.dp-bar .t { font-size: 13px; font-weight: 700; color: #111827; }
.dp-bar .d { font-size: 11px; color: #6b7280; margin-top: 2px; }
.dp-bar.dp-pos-bottom-left, .dp-bar.dp-pos-bottom-right {
  left: auto; right: auto; max-width: 380px; border-top: none;
  flex-direction: column; align-items: stretch;
  border: 1px solid #e2e6ec; border-radius: 12px; box-shadow: 0 8px 30px rgba(20,30,50,.16); }
.dp-bar.dp-pos-bottom-left { left: 16px; bottom: 16px; }
.dp-bar.dp-pos-bottom-right { right: 16px; bottom: 16px; }
.dp-bar.dp-pos-bottom-left .dp-btns, .dp-bar.dp-pos-bottom-right .dp-btns { justify-content: flex-end; flex-wrap: wrap; }
.dp-grow { flex: 1; min-width: 220px; }
.dp-btns { display: flex; gap: 8px; align-items: center; }
.dp-btn { font-size: 12px; font-weight: 600; padding: 9px 14px; border-radius: 8px; border: 1px solid transparent; cursor: pointer; }
.dp-accept { background: var(--dp-brand, #16a34a); color: var(--dp-brand-ink, #fff); }
.dp-reject { background: #fff; color: #374151; border-color: #cbd5e1; }
.dp-link { background: transparent; color: var(--dp-brand, #2563eb); text-decoration: underline; }
.dp-overlay { position: fixed; inset: 0; z-index: 2147483647; background: rgba(15,23,42,.45);
  display: flex; align-items: center; justify-content: center; padding: 16px; }
.dp-modal { background: #fff; border-radius: 12px; max-width: 440px; width: 100%; overflow: hidden; max-height: 90vh; display: flex; flex-direction: column; }
.dp-mhead { padding: 16px 18px 8px; } .dp-mhead .t { font-size: 15px; font-weight: 700; }
.dp-mhead .d { font-size: 11px; color: #6b7280; margin-top: 4px; }
.dp-rows { overflow: auto; }
.dp-row { display: flex; justify-content: space-between; gap: 12px; padding: 12px 18px; border-top: 1px solid #f1f3f6; }
.dp-row .name { font-size: 12px; font-weight: 600; } .dp-row .desc { font-size: 10.5px; color: #6b7280; margin-top: 2px; }
.dp-pill { font-size: 8.5px; font-weight: 700; color: #6b7280; background: #f1f3f6; padding: 2px 6px; border-radius: 6px; }
.dp-toggle { width: 36px; height: 20px; border-radius: 999px; background: #cbd5e1; position: relative; flex: none; border: none; cursor: pointer; }
.dp-toggle[aria-checked="true"] { background: var(--dp-brand, #2563eb); }
.dp-toggle[disabled] { background: #9ca3af; cursor: default; }
.dp-knob { position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; border-radius: 50%; background: #fff; transition: left .15s; }
.dp-toggle[aria-checked="true"] .dp-knob { left: 18px; }
.dp-mfoot { padding: 14px 18px; display: flex; gap: 8px; justify-content: flex-end; border-top: 1px solid #eef0f3; background: #fafbfc; }
.dp-note { font-size: 9.5px; color: #9ca3af; padding: 0 18px 12px; }
.dp-fab { position: fixed; left: 16px; bottom: 16px; z-index: 2147483645; background: #fff;
  border: 1px solid #e2e6ec; box-shadow: 0 4px 14px rgba(20,30,50,.14); border-radius: 999px;
  padding: 9px 14px; font-size: 12px; font-weight: 600; color: #374151; cursor: pointer; }
`;
